import { render, staticRenderFns } from "./upgradeContract.vue?vue&type=template&id=6be9df62&scoped=true"
import script from "./upgradeContract.vue?vue&type=script&lang=js"
export * from "./upgradeContract.vue?vue&type=script&lang=js"
import style0 from "./upgradeContract.vue?vue&type=style&index=0&id=6be9df62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be9df62",
  null
  
)

export default component.exports